import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { SectorDataForm } from '../../../app/models/Sector';
import SectorForm from './forms/SectorForm';
import { SectorBusinessRulesEnum } from '../../../app/shared/enums';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    sector: SectorDataForm;
    setSector: (sector: SectorDataForm) => void;
    errorFields?: any;
    sectorBusinessRulesEnum :SectorBusinessRulesEnum[]
}

const SectorFormContainer = ({
    fetching,
    action,
    cancel,
    sector,
    setSector,
    errorFields = null,
    sectorBusinessRulesEnum

}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <SectorForm
                        sectorDataForm={sector}
                        setSectorDataForm={setSector}
                        errorFields={errorFields}
                        sectorBusinessRulesEnum={sectorBusinessRulesEnum}

                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default SectorFormContainer;
